var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContractTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_contract_table",
    transform: "translate(-333 -409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-docs",
    transform: "translate(-61.536 110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_734",
    "data-name": "\\uC0AC\\uAC01\\uD615 734",
    transform: "translate(394.536 299)",
    fill: "#fff",
    stroke: "#ccc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 13,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_185",
    "data-name": "\\uC120 185",
    x2: 6.16,
    transform: "translate(336.5 412.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_186",
    "data-name": "\\uC120 186",
    x2: 6.16,
    transform: "translate(336.5 414.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_187",
    "data-name": "\\uC120 187",
    x2: 6.16,
    transform: "translate(336.5 416.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10353",
    "data-name": "\\uD328\\uC2A4 10353",
    d: "M0,0H3.16",
    transform: "translate(336.5 418.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractTable);
export default __webpack_public_path__ + "static/media/contract-table.e8e22dadd67929217575f2a028e77d70.svg";
export { ForwardRef as ReactComponent };